export const heightForContent = (rows = 1, bulmaSize = 'normal') => {
  const textHeight = bulmaSize === 'small' ? 0.75 : bulmaSize === 'large' ? 1.25 : 1

  return `${(rows * 2 + 1) * textHeight}rem`
}
